import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FaturaService } from './../../../services/fatura.service';
import { firstValueFrom } from 'rxjs';
import { IAgendaEduLog } from './../../../interfaces/iagenda-edu-log';
import { Fatura } from './../../../utils/fatura';
import { LogService } from '../../../services/log.service';
import { IAgendaEduAccessInfo } from '../../../interfaces/iagenda-edu-access-info';
import { AccessInfo } from './../../../utils/access-info';

@Component({
  selector: 'app-conheca-portal',
  templateUrl: './conheca-portal.component.html',
  styleUrls: ['./conheca-portal.component.scss'],
})
export class ConhecaPortalComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private faturaService: FaturaService,
    private logService: LogService,
    private route: ActivatedRoute
  ) {}

  linkData: string = ""
  linkLoaded: boolean = false
  urlShowFatura: string = '';

  acessoPortalLog: IAgendaEduLog = {
    responsibleToken: '',
    studentToken: '',
    message: 'Acessou o portal de auto negociacao',
    category: Fatura.categoryAcessoPortalNegociacaoFatura,
    urlOrigem: `/conheca-portal`,
    bankSlipAgendaEdu: null,
  };

  async ngOnInit()  {
    const faturaId = this.route.snapshot.queryParamMap.get('faturaId');
    this.linkData = await (await this.getLinkData()).toString()
    let accessInfo: IAgendaEduAccessInfo = AccessInfo.getAccessInfo();
    this.urlShowFatura = `/fatura/${faturaId}`;
  }


  async getLinkData () {
    const student: string = sessionStorage.getItem('studentID') || ""

        try {
            const linkData = await firstValueFrom(
              this.faturaService.getLinkPortal(student)
            );
            this.linkLoaded = true
            return linkData
          } catch (e: any) {
            let message: string = '';
            if (e !== null) {
              message =
                typeof e === 'object' && e.hasOwnProperty('message') ? e.message : '';
            }

            return ""
          }
  }

  onGoPortal (e: Event, link: String)  {
    e.preventDefault();
    this.logService.logAgendaEdu(this.acessoPortalLog).subscribe()
    window.open(link.toString(), "_blank");
  }
}
